// Axios
import axios from 'axios';

// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, Avatar, Badge, Blockquote, Cell, IconButton, Navigation, Section, Spinner, Switch } from '@telegram-apps/telegram-ui';

// VK
import { Snackbar } from '@vkontakte/vkui';
import { Icon28CheckCircleFill } from '@vkontakte/icons';

// Icons
import { ReactComponent as ModeIcon } from "../assets/mode.svg";

const tg = window.Telegram.WebApp;

const PromptsPage = ({ activePanel, setActivePanel, avatarSrc, selectedGroup, themes, setGptLink, setGptMedia, setGptText, setSelectedGroup, premodePosts, setChannels, setGroups, setPremodePosts, selectedStreamIndex, setSelectedStreamIndex, stream, setStream, prompts }) => {
    const filteredPosts = premodePosts.filter(post => selectedGroup === null || post.id === selectedGroup.id);
    const streams = selectedGroup.streams;
    const [promptLibrary, setPromptLibrary] = useState(stream.promptLibrary);
    const [prompt, setPrompt] = useState(stream.prompt);
    const [temp, setTemp] = useState(stream.temp);
    const [sign, setSign] = useState(stream.sign);
    const [snackbar, setSnackbar] = useState(null);
    const postStyles = prompts

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('style');
        };

        if (activePanel === 'prompts') {
            tg.BackButton.show();
            console.log(streams)
            console.log('Промпты:', prompts)
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        const saveStyle = async () => {
            console.log('test PromptLibrary')
            const url = 'https://api.gmpapp.ru/save_style';

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, temp: temp, prompt: prompt, sign: sign, promptLibrary: promptLibrary }),
                });

                if (!response.ok) {
                    // Здесь можно обрабатывать неуспешные коды ответов
                    console.error('Error:', response.status, response.statusText);
                } else {
                    // Если ответ успешен, можно сделать что-то с данными
                    const data = await response.json();
                    console.log('Success:', data);
                }
            } catch (error) {
                console.error('Error streams sending', error);
            }
        };

        saveStyle();
    }, [prompt, promptLibrary]);

    const openError = (text) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28CheckCircleFill fill="var(--vkui--color_icon_positive)" />}
            >
                {text}
            </Snackbar>,
        );
    };

    const handleChange = (prompt, promptLibrary, name, type) => {
        setPrompt(prompt);
        setPromptLibrary(promptLibrary);

        setStream((prevStream) => ({
            ...prevStream, // копируем предыдущее состояние
            prompt: prompt,
            promptLibrary: promptLibrary, // заменяем только promptLibrary
        }));

        openError(`Установлен промпт: ${name} (${type})`);
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Section className='sectionChannel sectionPrompts' header='Подводка'>
                    {postStyles
                        .filter(postStyle => postStyle.typeValue === 'lead')
                        .sort((a, b) => (parseInt(a.order ?? 0, 10)) - (parseInt(b.order ?? 0, 10)))
                        .map((postStyle) => (
                            <Cell
                                key={postStyle.id}
                                onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleChange(postStyle.value, postStyle.id, postStyle.label, postStyle.type); }}
                                className='settingsItem'
                                before={
                                    <span
                                        style={{
                                            width: "28px",
                                            height: "28px",
                                            marginBottom: "1px",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        {postStyle.icon}
                                    </span>
                                }
                                after={postStyle.id === stream.promptLibrary ? <Navigation>Установлен</Navigation> : null}>{postStyle.label}
                            </Cell>
                        ))}
                </Section>
                <Section className='sectionChannel sectionPrompts' header='Самостоятельный'>
                    {postStyles
                        .filter(postStyle => postStyle.typeValue === 'post')
                        .sort((a, b) => (parseInt(a.order ?? 0, 10)) - (parseInt(b.order ?? 0, 10)))
                        .map((postStyle) => (
                            <Cell
                                key={postStyle.id}
                                onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); handleChange(postStyle.value, postStyle.id, postStyle.label, postStyle.type); }}
                                className='settingsItem'
                                before={
                                    <span
                                        style={{
                                            width: "28px",
                                            height: "28px",
                                            marginBottom: "1px",
                                            borderRadius: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        {postStyle.icon}
                                    </span>
                                }
                                after={postStyle.id === stream.promptLibrary ? <Navigation>Установлен</Navigation> : null}>{postStyle.label}
                            </Cell>
                        ))}
                </Section>
                {snackbar}
            </AppRoot >
        </div >
    );
};

export default PromptsPage;